import { Container, Grid } from "@material-ui/core"
import { HistoricoAtualizacoesFiltro } from "./components/historico-atualizacoes-filtro/historico-atualizacoes-filtro"
import { HistoricoAtualizacoesList } from "./components/historico-atualizacoes-list/historico-atualizacoes-list"
import { CircularLoading } from "views/components"
import { HistoricoAtualizacoesSistemas } from "./components/historico-atualizacoes-sistemas/historico-atualizacoes-sistemas"
import { useEffect, useRef, useState } from "react"
import { useStyles } from "./historico-atualizacoes-styles"
import { useDefaultCadastroStyles } from "../cadastros/components/default-cadastro-styles"
import { HistoricoAtualizacoesHeader } from "./components/historico-atualizacoes-header/historico-atualizacoes-header"
import classNames from "classnames"

export const HistoricoAtualizacoesPage = ({ isPublic }: { isPublic?: boolean }) => {
    const [sistemaSelected, setSistemaSelected] = useState<string>("");
    const [historicoFiltro, setHistoricoFiltro] = useState<"data" | "versao">("versao");
    const [isCarregandoInterno, setIsCarregandoInterno] = useState<boolean>(false);
    const containerRef = useRef<HTMLDivElement>(null)

    const cadastroClasses = useDefaultCadastroStyles();
    const classes = useStyles();

    useEffect(() => {
        if (!isPublic) {
            setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.scrollIntoView({ behavior: "instant" as any, block: "start" });
                }
            }, 500)
        }
    }, [isPublic, sistemaSelected])

    return (
        <Grid className={classNames(cadastroClasses.root, classes.root)}>
            <Grid className={cadastroClasses.header}>
                {!isPublic && (
                    <HistoricoAtualizacoesHeader />
                )}
                <HistoricoAtualizacoesSistemas carregando={false} setSistemaSelected={setSistemaSelected} sistemaSelected={sistemaSelected} />
            </Grid>
            <Grid container justifyContent="flex-end">
                <HistoricoAtualizacoesFiltro historicoFiltro={historicoFiltro} setHistoricoFiltro={setHistoricoFiltro} />
            </Grid>
            <Grid container className={classes.container}>
                {isCarregandoInterno && <CircularLoading tipo="FULLSIZED" />}
                <Container maxWidth="md" ref={containerRef} className={classes.containerComp}>
                    <Grid container className={classes.content}>
                        <HistoricoAtualizacoesList
                            sistemaSelected={sistemaSelected}
                            historicoFiltro={historicoFiltro}
                            carregando={isCarregandoInterno}
                            setIsCarregandoInterno={setIsCarregandoInterno}
                        />
                    </Grid>
                </Container>
            </Grid>
        </Grid>
    )
}